if (process.env.NODE_ENV === 'production') {
  module.exports = require('./glyphs.production.js');
} else {
  module.exports = require('./glyphs.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/glyphs/dist/es/glyphs.js
// module id = 1417
// module chunks = 0